import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiBriefcase, FiUsers, FiCalendar } from 'react-icons/fi';
import api from '../../services/api';

const EmployeeProjectTasksPage = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const response = await api.get('/projects/my');
      setProjects(response.data.projects || []);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching projects:', err);
      setError('Failed to load projects. Please try again.');
      setLoading(false);
    }
  };



  if (loading) {
    return (
      <div className="p-6">
        <h1 className="text-2xl font-semibold mb-6">My Projects</h1>
        <div className="text-center py-8">Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-6">
        <h1 className="text-2xl font-semibold mb-6">My Projects</h1>
        <div className="text-center py-8 text-red-500">{error}</div>
        <button 
          onClick={fetchProjects} 
          className="mx-auto block px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
        >
          Try Again
        </button>
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-semibold">My Projects</h1>
      </div>

      {projects.length === 0 ? (
        <div className="bg-white shadow-md rounded-lg p-8 text-center">
          <FiBriefcase size={48} className="mx-auto text-gray-400 mb-4" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">No Projects Assigned</h3>
          <p className="text-gray-500">You don't have any projects assigned yet.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map(project => (
            <div key={project.id} className="bg-white shadow-md rounded-lg overflow-hidden hover:shadow-lg transition-shadow">
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <FiBriefcase className="text-blue-500 mr-3" size={24} />
                  <h3 className="text-lg font-semibold text-gray-900 truncate">{project.name}</h3>
                </div>
                
                {project.description && (
                  <p className="text-gray-600 text-sm mb-4 line-clamp-3">{project.description.replace(/<[^>]*>/g, '')}</p>
                )}
                
                <div className="flex items-center justify-between text-sm text-gray-500 mb-4">
                  {project.start_date && (
                    <div className="flex items-center">
                      <FiCalendar className="mr-1" size={14} />
                      <span>Started: {new Date(project.start_date).toLocaleDateString()}</span>
                    </div>
                  )}
                  {project.end_date && (
                    <div className="flex items-center">
                      <FiCalendar className="mr-1" size={14} />
                      <span>Due: {new Date(project.end_date).toLocaleDateString()}</span>
                    </div>
                  )}
                </div>
                
                <Link
                  to={`/employee/project-tasks?project=${project.id}`}
                  className="block w-full text-center bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600 transition-colors"
                >
                  View Tasks
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default EmployeeProjectTasksPage;